export default __webpack_public_path__ + "static/media/logo_transparent.e62d9338.svg";